import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid"
}
const _hoisted_2 = { class: "p-field p-col-6 p-float-label" }
const _hoisted_3 = {
  for: "datasetLabel",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-field p-col-5 p-float-label" }
const _hoisted_5 = {
  for: "datasetName",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Select Dataset")
const _hoisted_8 = { class: "table-header" }
const _hoisted_9 = { class: "p-input-icon-left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.selectedDataset)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_InputText, {
              id: "datasetLabel",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.selectedDataset.label,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDataset.label = $event)),
              modelModifiers: { trim: true },
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
          ]),
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              id: "datasetName",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.selectedDataset.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDataset.name = $event)),
              modelModifiers: { trim: true },
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Button, {
              icon: "pi pi-search-plus",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDatasetsDialog = true))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDatasetsDialog,
      modal: true,
      class: "full-screen-dialog p-fluid kn-dialog--toolbar--primary",
      closable: false,
      position: "right",
      baseZIndex: 1,
      autoZIndex: true
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0 p-col" }, {
          start: _withCtx(() => [
            _hoisted_7
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "pi pi-save",
              class: "p-button-text p-button-rounded p-button-plain",
              disabled: _ctx.buttonDisabled,
              onClick: _ctx.onSave,
              "data-test": "submit-button"
            }, null, 8, ["disabled", "onClick"]),
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDatasetsDialog = false)),
              "data-test": "close-button"
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.datasets,
          paginator: true,
          class: "p-datatable-sm kn-table p-ml-2 p-mr-2",
          dataKey: "id",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters = $event)),
          filterDisplay: "menu",
          globalFilterFields: _ctx.lovsManagementDatasetDescriptor.globalFilterFields,
          rows: 20,
          responsiveLayout: "stack",
          breakpoint: "960px",
          currentPageReportTemplate: 
                _ctx.$t('common.table.footer.paginated', {
                    first: '{first}',
                    last: '{last}',
                    totalRecords: '{totalRecords}'
                })
            ,
          selection: _ctx.selectedDataset,
          "onUpdate:selection": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedDataset = $event)),
          selectionMode: "single"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  type: "text",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  placeholder: _ctx.$t('common.search'),
                  badge: "0",
                  "data-test": "search-input"
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                field: col.field,
                header: _ctx.$t(col.header),
                key: col.field,
                sortable: true,
                style: col.style,
                class: "kn-truncated"
              }, {
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                    class: "p-column-filter"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                body: _withCtx((slotProps) => [
                  _createVNode("span", {
                    title: slotProps.data[col.field]
                  }, _toDisplayString(slotProps.data[col.field]), 9, ["title"])
                ]),
                _: 2
              }, 1032, ["field", "header", "style"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "filters", "globalFilterFields", "currentPageReportTemplate", "selection"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}